export default function convertSnakeToPascalCase(feedName: string): string {
  return feedName
    .split('_')
    .map((str) => str.charAt(0).toUpperCase() + str.substring(1).toLowerCase())
    .join('');
}
